import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet-async';
import { pageTitle } from '../../../util/pageTitles';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';

import NoData from '../../../components/NoData/NoData';
import { setChart } from '../../../components/Filter/FilterActions';
import { setPageName } from './../../App/AppActions';
import { getData, getOnTimeData } from '../DueDatePerformanceActions';
import DDPDetailsAccordion from '../../../components/DetailsAccordion/DDPDetailsAccordion';

import Filter from '../../../components/Filter/Filter';
import { DatePicker, Options } from '../../../components/Filter/components';

import DDPChart from '../components/DDPChart';
import OnTimeDeliveryWidget from '../components/OnTimeDeliveryWidget';

import { 
  trackTeamDashboardView, 
  trackChartPointDetailsView,
  trackHowToOpened 
} from '../../../util/mixpanel';

import './../DueDatePerformance.scss';

class DueDatePerformance extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedPoint: {}
    };

    props.dispatch(setPageName('Due Date Performance Chart'));
  }

  componentDidMount() {
    if (this.props.dashboard && this.props.dashboard._id && this.props.dataIsLoading === false) {
      this.props.setChart('ddp');

      trackTeamDashboardView('ddp');
    }
  }

  componentDidUpdate(prevProps) {
    if (
      (prevProps.dataHash != this.props.dataHash || prevProps.hash != this.props.hash) &&
      this.props.dataIsLoading === false
    ) {
      this.handleChange();
    }

    if (prevProps.lineChart !== this.props.lineChart && this.props.lineChart) {
      this.props.getOnTimeData();
    }
  }

  handleChange(force) {
    if (force || !this.props.dataIsLoading) {
      this.setState({
        selectedPoint: {}
      });
      this.props.getData();
      if (this.props.lineChart) {
        this.props.getOnTimeData();
      }
    }
  }

  handlePointClick = point => {
    this.setState({
      selectedPoint: point
    });

    trackChartPointDetailsView('ddp', true);
  };

  trackHowToDDPOpen() {
    trackHowToOpened('ddp');
  }

  render() {
    const tooltip = (
      <div className="more_info_tooltip">
        <div className="more_info-inner">
          <p>Use the chart to:</p>
          <ul>
            <li>Evaluate your due date performance</li>
            <li>Analyze your delayed work</li>
            <li>Measure your on-time delivery ratio</li>
          </ul>
          <a
            href={`https://getnave.com/due-date-performance-chart`}
            target="_blank"
            onClick={this.trackHowToDDPOpen}
            onAuxClick={this.trackHowToDDPOpen}
            className='btn btn-secondary'
            >
              Learn more
          </a>
        </div>
      </div>
    );

    const totalItems = !this.props.data ? 0 : _.reduce(this.props.data.series, (p, c) => {
      return p + (c.data && c.data.length || 0);
    }, 0);

    return (
      <div className="content-wrap">
        <Helmet>
          <title>{pageTitle(`Due Date Performance Chart${this.props.dashboard ? ' | ' + this.props.dashboard.name : ''}`)}</title>
        </Helmet>
        <Filter totalItems={totalItems} timeunit tasksType disable={['lists']} doneStatus={this.props.doneStatus} enableMarkBlocked />
        <div className="chart_box_view">
          <div className="dashboard_head">
            <div className="flex-layout">
              <h1>Due Date Performance Chart</h1>
              <div className="more_info_content">
                <span className="more_info"></span>
                {tooltip}
              </div>
            </div>
            <div className="button_tools">
              <Options showLineChart />
              <DatePicker />
            </div>
          </div>
          <div>
            <div className="dashboard_details">
              <DDPDetailsAccordion id="details-accordion" data={this.state.selectedPoint} blockedTime={this.props.blockedTime} blockers={this.props.blockers} />
              {this.props.lineChart && this.props.ontimeData && !!this.props.ontimeData.length && (
                <OnTimeDeliveryWidget id="ontime_delivery" data={this.props.ontimeData} widget="otd" />
              )}
            </div>
            <div className="diagram_details">
              <DDPChart id="DDP" data={this.props.data} onPointClick={this.handlePointClick} />
              <NoData show={this.props.data.series && !this.props.data.series.length} loading={this.props.isLoading} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setChart: name => dispatch(setChart(name)),
    getData: () => dispatch(getData()),
    getOnTimeData: () => dispatch(getOnTimeData())
  };
};

const mapStateToProps = state => {
  const doneStatus = state.filters.allDones.length > 1;
  return {
    app: state.app.app,
    hash: state.filters.ddp.hash,
    lineChart: state.filters.ddp.lineChart,
    blockedTime: state.filters.ddp.blockedTime,
    blockers: state.filters.ddp.blockers,
    data: state.ddp.data,
    ontimeData: state.ddp.ontimeData,
    isLoading: state.ddp.isLoading,
    dashboard: state.dashboards.selected,
    dataIsLoading: state.app.isLoading,
    dataHash: state.app.dataHash,
    doneStatus
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DueDatePerformance);
